import { useNavigate } from "react-router-dom";
import { getValidLineOfficialAccountUrl } from "../lib/lineOfficialAccount";

export default function LineRegisterComplete() {
  const navigate = useNavigate();
  const lineOfficialAccountUrl = getValidLineOfficialAccountUrl();

  const handleReturnToLine = () => {
    if (lineOfficialAccountUrl) {
      window.location.assign(lineOfficialAccountUrl);
    }
  };

  const hasLineUrl = Boolean(lineOfficialAccountUrl);

  return (
    <main className="flex min-h-screen select-none items-center justify-center bg-[#FDF8F5] px-6 text-[#4A3E39] antialiased">
      <div className="w-full max-w-sm">
        <div className="relative overflow-hidden rounded-[2.2rem] border border-[#EADBC8] bg-white/70 shadow-[0_14px_28px_rgba(166,124,82,0.16)] backdrop-blur-sm">
          <div className="pointer-events-none absolute -right-8 -top-10 h-32 w-32 rounded-full bg-[#F4E3D7] opacity-70 blur-3xl" />

          <div className="px-8 pb-10 pt-12 text-center">
            <p className="text-[11px] font-bold tracking-[0.12em] text-[#A67C52]">PERSONAL CONCIERGE</p>
            <h1 className="mt-1 text-3xl font-black tracking-tight text-[#7C5A4E]">WizMate</h1>

            <div className="mx-auto mb-6 mt-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#F0FAF5] border-4 border-[#A8DFC0]">
              <svg className="h-10 w-10 text-[#34A853]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>

            <p className="text-lg font-bold text-[#5D4D46]">LINEで使える準備ができました</p>
            <p className="mt-2 text-sm text-[#7B6861]">
              LINEでWizMateを開くと、そのまま話しかけられます。
            </p>

            {hasLineUrl ? (
              <button
                type="button"
                onClick={handleReturnToLine}
                className="mt-8 w-full rounded-2xl bg-[#06C755] px-4 py-4 text-sm font-bold text-white shadow-[0_4px_12px_rgba(6,199,85,0.3)] transition hover:bg-[#05b34d] active:scale-[0.99]"
              >
                LINEでWizMateを開く
              </button>
            ) : (
              <p className="mt-8 text-sm font-bold text-[#5D4D46]">LINEアプリに戻り、WizMateとのトークを開いてください。</p>
            )}

            <button
              type="button"
              onClick={() => navigate("/home", { replace: true })}
              className="mt-3 w-full rounded-2xl border border-[#EADBC8] bg-white px-4 py-4 text-sm font-bold text-[#5D4D46] transition hover:bg-[#FDF8F5] active:scale-[0.99]"
            >
              Web版を開く
            </button>
          </div>

          <div className="border-t border-[#EADBC8] px-6 py-4 text-center">
            <p className="text-[11px] text-[#9C867D]">© WizMate</p>
          </div>
        </div>
      </div>
    </main>
  );
}
